import script from "./ConfigureFieldsGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigureFieldsGroup.vue?vue&type=script&setup=true&lang=js"

import "./ConfigureFieldsGroup.vue?vue&type=style&index=0&id=4f0127ff&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f0127ff"]])

export default __exports__